import { DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../../assets/styles/modals.css";

export const ModalHeader = (props: any) => {
  const {
    icon,
    text,
    className = "",
    onCancel,
    clearState,
    disabledButton = false,
  } = props;

  return (
    <DialogTitle className="modal-header">
      <div className={className}>
        {typeof text === "string" && (
          <div className={className}>
            {Boolean(icon) && icon}
            <Typography
              className="ml2"
              sx={{ textTransform: "uppercase", fontSize: 14, fontWeight: 600 }}
            >
              {text || ""}
            </Typography>
          </div>
        )}
        {typeof text !== "string" && text}
        {!disabledButton && (
          <IconButton
            aria-label="Cerrar"
            onClick={() => {
              onCancel && onCancel();
              clearState && clearState();
            }}
            {...(typeof text !== "string"
              ? { sx: { position: "absolute", top: 10, right: 8 } }
              : {})}
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>
    </DialogTitle>
  );
};
